export default {

  uploader: {
    "title": "Subir fichero",
    "uploaderSentence": "Suelta tu archivo aquí o <em>haz clic para cargar</em>",
    "fileTypeSentence": "Solo archivos jpg/png con un tamaño menor de 500kb",
    "successTitle": "Subido correctamente",
    "successMessage": "Fichero {0} subido correctamente."
  }
}